import { render, staticRenderFns } from "./Maintmessages.vue?vue&type=template&id=3a60e950&"
import script from "./Maintmessages.vue?vue&type=script&lang=js&"
export * from "./Maintmessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports